import api from "@/api";
import { lightTheme } from "@/index";
import { getCurrentInfo, getParameter, setLocalStorage } from "@/utilities/common";
import { MAPAccountStatusEnum } from "@/utilities/common_enum";
import { goToMap } from "@/utilities/function";
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, FluentProvider } from "@fluentui/react-components";
import React, { useEffect } from "react";
import expiryPageStyle from "./expiryPage.modules.less";
const InfoItem = ({ label, value }: { label: string; value: string }): JSX.Element => {
  return <div style={{ display: "flex", gap: "8px", rowGap: 4 }}>
    <span style={{ width: 144 }}>{label}</span>
    <span>{value}</span>
  </div>;
};
const ExpiryPage = (): JSX.Element => {
  const AID = Number(getParameter("aid"));
  const [open, setOpen] = React.useState(false);
  const [accountInfo, setAccountInfo] = React.useState<any>({});
  const isCN = getCurrentInfo("region")?.toLowerCase() === "zh-cn";
  useEffect(() => {
    if (AID === 0) {
      setOpen(false);
      return;
    }
    if (isCN) return;
    api.CrossBorder.getMAPAccountStatus({ aid: AID }).then((res:any) => {
      if (res) {
        setAccountInfo({ ...res });
        setLocalStorage("MAPAccountStatus", res?.valid);
        setOpen(res.valid === MAPAccountStatusEnum.Abnormal);
      }
    });
  }, [AID]);
  return (
    <FluentProvider theme={lightTheme} className={expiryPageStyle["fluent-provider"]}>
      <Dialog open={open}>
        <DialogSurface style={{ width: 544 }}>
          <DialogBody>
            <DialogTitle style={{ fontSize: 20, color: "#323130" }} action={null}>Related account status on MAP has been detected as invalid</DialogTitle>
            <DialogContent>
              <span style={{ color: "#605E5C", fontSize: 14 }}>Please note that your account status on MAP has been detected as invalid since {accountInfo.since}(UTC). Please update it on MAP within 72 hours. If your account on MAP is still invalid before {accountInfo.before}(UTC), your advertisings related to this account in BZA will be suspended and billing will be stopped. To avoid affecting your advertising, please update it in MAP as soon as possible.</span>
              <div style={{ backgroundColor: "#F5F5F5", padding: "16px", marginTop: 24 }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InfoItem label="Manager Account:" value={accountInfo.managerAccountName}/>
                <InfoItem label="Manager Account ID:" value={accountInfo.managerAccountId}/>
                <InfoItem label="Account:" value={accountInfo.mapAccountName}/>
                <InfoItem label="Account ID:" value={accountInfo.mapAccountId}/>
                <InfoItem label="Account Status:" value={accountInfo.accountStatus}/>
              </div>
              </div>
            </DialogContent>
            <DialogActions style={{ marginTop: 32 }}>
              <Button appearance="primary" onClick={goToMap}>Go to MAP</Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
    </Dialog>
    </FluentProvider>
  );
};

export default ExpiryPage;
